module.exports = __webpack_public_path__ + "static/media/cancel.ec62ffac.svg";